(function($) {

    var scrollPos = 0,
        $body = $('body'),
        homeHeader = $( '#homepage-sliding-header' ),
        headerHeight = homeHeader.outerHeight(),
        logo = $( '#main-nav .main-nav-item.first' );

	$(document).ready(function() {

        constant(); // start listening for scroll position

    });

    // Detect request animation frame to use in effect of on.scroll
    var scroll = window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.msRequestAnimationFrame ||
                window.oRequestAnimationFrame ||
                // IE Fallback, you can even fallback to onscroll
                function( callback ){ window.setTimeout( callback, 1000/60 ) };

    // check scroll position
    function constant() {

        // if the scroll depth has not changed, stop here
        if ( scrollPos === window.pageYOffset ) {
            scroll( constant );
            return false;
        } else { // if moved, store the new position
            scrollPos = window.pageYOffset;
        }

        // hide header color over page heroes
        if ( scrollPos < headerHeight*2 ) {
            // logo.addClass( 'opacity-0' );
        } else {
            // logo.removeClass( 'opacity-0' );
        }

        scroll(constant); // recall the Request Animation Frame

    }

})( jQuery );